'use strict';

var tslib = require('tslib');
var React = require('react');
var deepEqual = require('deep-equal');
var utils = require('./utils.js');
var components_optionsList_Component = require('./components/options-list/Component.js');
var consts = require('./consts.js');
var presets_useSelectWithApply_optionsListWithApply_footer_Component = require('./presets/useSelectWithApply/options-list-with-apply/footer/Component.js');
var presets_useSelectWithApply_optionsListWithApply_header_Component = require('./presets/useSelectWithApply/options-list-with-apply/header/Component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var deepEqual__default = /*#__PURE__*/_interopDefaultCompat(deepEqual);

var OptionsListWithApply = React.forwardRef(function (_a, ref) {
    var toggleMenu = _a.toggleMenu, defaultGetOptionProps = _a.getOptionProps, _b = _a.showClear, showClear = _b === void 0 ? true : _b, showHeaderWithSelectAll = _a.showHeaderWithSelectAll, _c = _a.selectedDraft, selectedDraft = _c === void 0 ? [] : _c, _d = _a.flatOptions, flatOptions = _d === void 0 ? [] : _d, _e = _a.OptionsList, OptionsList = _e === void 0 ? components_optionsList_Component.OptionsList : _e, _f = _a.onApply, onApply = _f === void 0 ? function () { return null; } : _f, _g = _a.onClear, onClear = _g === void 0 ? function () { return null; } : _g, _h = _a.onClose, onClose = _h === void 0 ? function () { return null; } : _h, _j = _a.visibleOptions, visibleOptions = _j === void 0 ? consts.DEFAULT_VISIBLE_OPTIONS : _j, _k = _a.Footer, Footer = _k === void 0 ? presets_useSelectWithApply_optionsListWithApply_footer_Component.Footer : _k, _l = _a.Header, Header = _l === void 0 ? presets_useSelectWithApply_optionsListWithApply_header_Component.Header : _l, header = _a.header, headerProps = _a.headerProps, setSelectedDraft = _a.setSelectedDraft, restProps = tslib.__rest(_a, ["toggleMenu", "getOptionProps", "showClear", "showHeaderWithSelectAll", "selectedDraft", "flatOptions", "OptionsList", "onApply", "onClear", "onClose", "visibleOptions", "Footer", "Header", "header", "headerProps", "setSelectedDraft"]);
    var getOptionProps = React.useCallback(function (option, index) {
        var optionProps = defaultGetOptionProps(option, index);
        var selected = option.key === SELECT_ALL_KEY
            ? selectedDraft.length === flatOptions.length - 1
            : selectedDraft.some(function (_a) {
                var key = _a.key;
                return key === option.key;
            });
        return tslib.__assign(tslib.__assign({}, optionProps), { selected: selected });
    }, [defaultGetOptionProps, flatOptions.length, selectedDraft]);
    var handleApply = React.useCallback(function () {
        onApply();
        toggleMenu();
    }, [onApply, toggleMenu]);
    var handleClear = React.useCallback(function () {
        onClear();
        toggleMenu();
    }, [onClear, toggleMenu]);
    var handleSelectedItems = React.useCallback(function (items) {
        setSelectedDraft === null || setSelectedDraft === void 0 ? void 0 : setSelectedDraft(items);
    }, [setSelectedDraft]);
    React.useEffect(function () {
        var activeElement = document.activeElement;
        return function () {
            onClose();
            if (activeElement) {
                activeElement.focus();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var renderHeader = function () {
        if (!showHeaderWithSelectAll && !header)
            return undefined;
        return (React__default.default.createElement(React__default.default.Fragment, null,
            header,
            showHeaderWithSelectAll && flatOptions.length > 0 && (React__default.default.createElement(Header, tslib.__assign({}, headerProps)))));
    };
    return (React__default.default.createElement(OptionsList, tslib.__assign({}, restProps, { ref: ref, visibleOptions: visibleOptions, toggleMenu: toggleMenu, flatOptions: flatOptions, getOptionProps: getOptionProps, onApply: handleApply, onClear: handleClear, header: renderHeader(), selectedItems: selectedDraft, setSelectedItems: handleSelectedItems, footer: React__default.default.createElement(Footer, { handleApply: handleApply, handleClear: handleClear, showClear: showClear, selectedDraft: selectedDraft, dataTestId: restProps === null || restProps === void 0 ? void 0 : restProps.dataTestId }) })));
});

var SELECT_ALL_KEY = 'select_all';
var selectAllOption = { key: SELECT_ALL_KEY, content: 'Выбрать все' };
function useSelectWithApply(_a) {
    var _b, _c;
    var options = _a.options, selected = _a.selected, _d = _a.onChange, onChange = _d === void 0 ? function () { return null; } : _d, _e = _a.onSelectAllClick, onSelectAllClick = _e === void 0 ? function () { return null; } : _e, OptionsList = _a.OptionsList, _f = _a.optionsListProps, optionsListProps = _f === void 0 ? {} : _f, _g = _a.showClear, showClear = _g === void 0 ? true : _g, _h = _a.showSelectAll, showSelectAll = _h === void 0 ? false : _h, _j = _a.showHeaderWithSelectAll, showHeaderWithSelectAll = _j === void 0 ? false : _j, _k = _a.showSearch, showSearch = _k === void 0 ? false : _k, _l = _a.searchProps, searchProps = _l === void 0 ? {} : _l;
    var _m = React.useState(''), searchState = _m[0], setSearchState = _m[1];
    var _o = typeof (searchProps === null || searchProps === void 0 ? void 0 : searchProps.value) === 'string'
        ? [searchProps.value, searchProps.onChange]
        : [searchState, setSearchState], search = _o[0], setSearch = _o[1];
    var accessor = searchProps.accessor || utils.defaultAccessor;
    var filterFn = searchProps.filterFn || utils.defaultFilterFn;
    var groupAccessor = (_b = searchProps.groupAccessor) !== null && _b !== void 0 ? _b : utils.defaultGroupAccessor;
    var filterGroup = (_c = searchProps.filterGroup) !== null && _c !== void 0 ? _c : false;
    var _p = React.useMemo(function () {
        return utils.processOptions(options, selected, showSearch
            ? function (option) {
                if (utils.isGroup(option)) {
                    var groupAccessorValue = groupAccessor(option);
                    return (typeof groupAccessorValue === 'string' &&
                        filterFn(groupAccessorValue, search));
                }
                return filterFn(accessor(option), search);
            }
            : undefined, filterGroup);
    }, [options, selected, showSearch, filterGroup, filterFn, accessor, search, groupAccessor]), flatOptions = _p.flatOptions, filteredOptions = _p.filteredOptions, selectedOptions = _p.selectedOptions;
    var _q = React.useState(selectedOptions), selectedDraft = _q[0], setSelectedDraft = _q[1];
    var selectedOptionsRef = React.useRef(selectedOptions);
    var handleApply = function () {
        onChange({
            selected: selectedDraft[0],
            selectedMultiple: selectedDraft,
            initiator: null,
            name: 'apply-footer',
        });
    };
    var handleClear = function () {
        setSelectedDraft([]);
        onChange({
            selected: null,
            selectedMultiple: [],
            initiator: null,
            name: 'reset-footer',
        });
    };
    var handleToggleAll = function () {
        var optionsToSet = flatOptions.length === selectedDraft.length ? [] : flatOptions;
        onSelectAllClick(optionsToSet);
        setSelectedDraft(optionsToSet);
    };
    var selectedKeys = React.useMemo(function () { return selectedDraft.map(function (_a) {
        var key = _a.key;
        return key;
    }); }, [selectedDraft]);
    var handleChange = function (_a) {
        var initiator = _a.initiator, restArgs = tslib.__rest(_a, ["initiator"]);
        if (!initiator) {
            onChange(tslib.__assign({ initiator: null }, restArgs));
            return;
        }
        var initiatorSelected = selectedDraft.some(function (selectedDraftOption) { return selectedDraftOption.key === initiator.key; }) ||
            (initiator.key === SELECT_ALL_KEY &&
                (selectedDraft.length === flatOptions.length ||
                    flatOptions.every(function (_a) {
                        var key = _a.key;
                        return selectedKeys.includes(key);
                    })));
        if (initiator.key === SELECT_ALL_KEY) {
            setSelectedDraft(initiatorSelected ? [] : flatOptions);
        }
        else {
            setSelectedDraft(initiatorSelected
                ? selectedDraft.filter(function (o) { return o.key !== initiator.key; })
                : selectedDraft.concat(initiator));
        }
    };
    var handleClose = function () { return setSelectedDraft(selectedOptionsRef.current); };
    React.useEffect(function () {
        // устанавливать selectedDraft если selectedOptions изменились
        if (!deepEqual__default.default(selectedOptionsRef.current, selectedOptions)) {
            setSelectedDraft(selectedOptions);
        }
        selectedOptionsRef.current = selectedOptions;
    }, [selectedOptions]);
    var memoizedOptions = React.useMemo(function () {
        return filteredOptions.length && showSelectAll
            ? tslib.__spreadArray([selectAllOption], filteredOptions, true) : filteredOptions;
    }, [filteredOptions, showSelectAll]);
    return {
        OptionsList: OptionsListWithApply,
        optionsListProps: tslib.__assign(tslib.__assign({}, optionsListProps), { OptionsList: OptionsList, showClear: showClear, onClear: handleClear, onApply: handleApply, onClose: handleClose, selectedDraft: selectedDraft, setSelectedDraft: setSelectedDraft, showHeaderWithSelectAll: showHeaderWithSelectAll, headerProps: tslib.__assign(tslib.__assign({}, optionsListProps === null || optionsListProps === void 0 ? void 0 : optionsListProps.headerProps), { indeterminate: selectedDraft.length > 0, checked: selectedDraft.length === flatOptions.length ||
                    flatOptions.every(function (_a) {
                        var key = _a.key;
                        return selectedKeys.includes(key);
                    }), onChange: handleToggleAll }) }),
        allowUnselect: true,
        multiple: true,
        options: memoizedOptions,
        onChange: handleChange,
        selected: selected,
        showSearch: showSearch,
        searchProps: showSearch
            ? tslib.__assign(tslib.__assign({}, searchProps), { value: search, onChange: setSearch }) : undefined,
        /* Костыль для респонсив селекта. В мобильную версию хук уже зашит, и это единственный передать в мобилку оригинальные пропсы */
        originalProps: {
            options: options,
            selected: selected,
            onChange: onChange,
            OptionsList: OptionsList,
            optionsListProps: optionsListProps,
            showClear: showClear,
            showSelectAll: showSelectAll,
            showHeaderWithSelectAll: showHeaderWithSelectAll,
            showSearch: showSearch,
            searchProps: searchProps,
        },
    };
}

exports.OptionsListWithApply = OptionsListWithApply;
exports.SELECT_ALL_KEY = SELECT_ALL_KEY;
exports.useSelectWithApply = useSelectWithApply;
